import { isNotCommunicated } from '@cibli/shared';

export function isNotEmpty(value: string | null | undefined): boolean {
  if (!value) return false;
  const trimmed = value.trim();
  if (trimmed === '' || trimmed === 'null') return false;
  return !isNotCommunicated(trimmed);
}
